module.exports = __webpack_public_path__ + "media/images/brands/brand-ir-27c1d6ae7b4dc081a69c53997fcd71c9.jpg";